<!-- <ion-header>
<ion-toolbar class="primary-color-background">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="header-content">
    <div fxLayout="row" fxLayoutAlign="center center" class="start-buttons m-l-15">
      <ion-buttons class="font-size-22">
        <ion-menu-button></ion-menu-button>
      </ion-buttons>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="logo-container">
      <img src="{{_appService._themingService.currentLogo.value.logoUrl}}" class="w-35 header_logo">
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="end-buttons m-r-5">
      <ion-button (click)="closeModal()" class="font-size-16" slot="end" fill="clear">
        <i class="bi bi-x"></i>
      </ion-button>
    </div>
  </div>
</ion-toolbar>
</ion-header> -->

<ion-header style="border-bottom: 0.5px solid gray;">
  <ion-toolbar class="header-background-style" style="position: relative; min-height: 56px;">
    <ion-title>
      <img src="{{_appService._themingService.currentLogo.value.logoUrl}}" class="header-logo" />
    </ion-title>
    <ion-buttons slot="end" style="z-index: 2;">
      <ion-buttons class="p-5 b-1 b-r-4 font-size-22 white-background" (click)="closeModal()">
        <i class="bi bi-x"></i>
      </ion-buttons>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="white-background">
  <div fxLayout="column" fxLayoutAlign="center center" class="p-0 inter-bold font-size-20">
    <!-- Header Section -->
    <div class="text-align-center m-t-5">
      <h2 class="inter-bold font-size-20 m-t-5 m-b-5 m-l-0 m-r-0">{{'self_pwa_text.Choose_Language_text' |
      translate}}</h2>
      <p style="color: gray;" class="inter-regular font-size-16 m-0">
        {{'self_pwa_text.Choose_language_you_want_to_use_text' | translate}}
      </p>
    </div>
    <ion-card class="ion-no-padding card-background w-95">
      <ion-card-content class="p-d-0">
        <ion-list lines="full" class="p-d-0">
          @for (item of languagewithFlag; track item) {
            <ion-item
              [ngClass]="{'selected-language': item.code == selectedLanguage}" style="align-items: center;">
              <ion-label class="inter-medium font-size-14" (click)="selectLanguage(item.code)">{{item.value}}</ion-label>
              <span class="inter-medium font-size-14"
              [ngStyle]="{ 'color': item.code == selectedLanguage ? 'white' : 'inherit' }">{{item.code}}</span>
            </ion-item>
          }
        </ion-list>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>